import styled from '@emotion/styled'
import { BookingCTA } from 'app/components/BookingCTA'
import { IconsList } from 'app/components/IconsList'
import { Mosaic } from 'app/components/Mosaic'
import { OtherRooms } from 'app/components/OtherRooms'
import { RoomHero } from 'app/components/RoomHero'
import { RoomIntro } from 'app/components/RoomIntro'
import { SEO } from 'app/components/SEO'
import {
  Props as StructuredDataProps,
  StructuredData,
} from 'app/components/StructuredData'
import { Footer, Props as FooterProps } from 'app/containers/Footer'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import { PageProps } from 'gatsby'
import React, { memo } from 'react'

import { Props } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
  footerProps?: FooterProps
  structuredDataProps?: StructuredDataProps
}

export interface Context extends PageContext {
  props: Props
}

export default memo(function RoomPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <Container>
      <SEO {...context.seoProps} />
      {context.structuredDataProps ? (
        <StructuredData
          languageCode={pageContext.languageCode}
          {...context.structuredDataProps}
        />
      ) : null}
      {context.headerProps ? (
        <Header
          pageID={context.id}
          languageCode={context.languageCode}
          languagePrefix={context.languagePrefix}
          variant="compact"
          {...context.headerProps}
        />
      ) : null}
      {context.roomHeroProps ? <RoomHero {...context.roomHeroProps} /> : null}
      {context.roomIntroProps ? (
        <RoomIntro {...context.roomIntroProps} />
      ) : null}
      {context.mosaicProps ? <Mosaic {...context.mosaicProps} /> : null}
      {context.iconsListProps ? (
        <IconsList {...context.iconsListProps} />
      ) : null}
      {context.bookingCTAProps ? (
        <BookingCTA {...context.bookingCTAProps} />
      ) : null}
      {context.otherRoomsProps ? (
        <OtherRooms {...context.otherRoomsProps} />
      ) : null}
      {context.footerProps ? (
        <Footer languageCode={context.languageCode} {...context.footerProps} />
      ) : null}
    </Container>
  )
})

const Container = styled.main``
